var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "material-notification" },
    [
      _c(
        "transition-group",
        {
          attrs: {
            "enter-active-class": "animate__animated animate__fadeInLeft",
            "leave-active-class": "animate__animated animate__bounceOutRight",
          },
        },
        _vm._l(_vm.notifications, function (notification, key) {
          return _c(notification.component, {
            key: notification.id,
            tag: "component",
            staticClass: "material-notification__item",
            attrs: { data: notification.data },
            on: {
              "notify-remove": function ($event) {
                return _vm.remove(key)
              },
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }